import React, { forwardRef } from "react";
import { Dropdown } from "semantic-ui-react";

const LabeledSelect = forwardRef(({ label, ...rest }, ref) => (
  <div style={{ display: "flex" }}>
    <div
      style={{
        backgroundColor: "#e8e8e8",
        color: "rgba(0,0,0,.6)",
        fontWeight: 700,
        border: "1px solid #dfdfdf",
        borderRightStyle: "none",
        borderRadius: "0.25rem",
        borderTopRightRadius: "0",
        borderBottomRightRadius: "0",
        padding: "0.5em 0.4em",
      }}
    >
      {label}
    </div>
    <Dropdown
      selection
      ref={ref}
      style={{
        borderTopLeftRadius: "0",
        borderBottomLeftRadius: "0",
      }}
      {...rest}
    />
  </div>
));

export default LabeledSelect;
